import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxPasswordFormComponent } from './rx-password-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxFormControlErrorsModule } from '@nrwl/rx-form-errors';
import { RxInputModule } from '@nrwl/rx-input';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxInputModule,
    RxFormControlErrorsModule,
    RxPasswordFormComponent,
  ],
  exports: [RxPasswordFormComponent],
})
export class RxPasswordFormModule {}
